import { claimPackExecution } from '../src/global/packExecutionGuard';

// First-wins guard against double execution when the asset rescue watchdog
// (assetRescueWatchdog.inline.js) has injected a GCS copy of this pack and the
// stalled CDN copy finishes loading later. Whichever copy executes first claims
// the pack and boots the SPA; the loser must no-op — a second execution would
// duplicate the Sentry init, the axios interceptor, and the React render.
// The SPA body lives in src/medsenderEntry.jsx; require (not import) so the
// guard actually gates module evaluation — ESM imports are hoisted.
if (claimPackExecution('medsender')) {
  // eslint-disable-next-line global-require
  require('../src/medsenderEntry');
}
